<template>
    <div class="custom-select-wrapper" :class="{ open: isOpen }">
        <div class="custom-select-trigger" @click.stop="toggleOpen">
            <span>{{ (selectedLabel).indexOf("Other.") == -1 ? selectedLabel : $t(selectedLabel) }}</span>
            <i class="el-icon-arrow-down" />
        </div>
        <div class="custom-select-dropdown">
            <div v-for="item in options" :key="item.value || item.id" class="custom-select-option"
                :class="{ active: value === (item.value || item.id) }"
                @click.stop="selectOption(item.value || item.id)">
                <div>
                    <div>
                        {{ item.label ? ((item.label).indexOf("Other.") == -1 ? item.label : $t(item.label)) : item.name
                        }}
                    </div>
                    <div><span>{{ item.desc }}</span></div>
                </div>
                <i v-if="value === (item.value || item.id)" class="el-icon-check" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CustomSelect',
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        options: {
            type: Array,
            default: () => []
        },
        placeholder: {
            type: String,
            default: 'CustomSelect.请选择'
        }
    },
    data() {
        return {
            isOpen: false
        }
    },
    computed: {
        selectedLabel() {
            const selected = this.options.find(item => String(item.value || item.id) === String(this.value || item.id))
            return selected ? (selected.label || selected.name) : this.$t(this.placeholder)
        }
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside)
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside)
    },
    methods: {
        toggleOpen(e) {
            e.stopPropagation()
            this.isOpen = !this.isOpen
        },
        selectOption(value) {
            this.$emit('change', value)
            this.isOpen = false
        },
        handleClickOutside(e) {
            const wrapper = this.$el
            if (wrapper && !wrapper.contains(e.target)) {
                this.isOpen = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.custom-select-wrapper {
    position: relative;
    width: 100%;

    .custom-select-trigger {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 16px;
        background: rgba(8, 8, 15, 0.9);
        border: 1px solid rgba(99, 102, 241, 0.3);
        border-radius: 12px;
        color: #f1f5f9;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s ease;
        height: 48px;

        &:hover {
            border-color: #6366f1;
            background: rgba(15, 15, 26, 0.95);
        }

        i {
            color: #818cf8;
            font-size: 12px;
            transition: transform 0.3s ease;
        }
    }

    &.open {
        .custom-select-trigger {
            border-color: #6366f1;
            box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.2);

            i {
                transform: rotate(180deg);
            }
        }

        .custom-select-dropdown {
            opacity: 1;
            visibility: visible;
            transform: translateY(0);
        }
    }

    .custom-select-dropdown {
        position: absolute;
        top: calc(100% + 8px);
        left: 0;
        right: 0;
        background: #0f0f1a;
        border: 1px solid rgba(99, 102, 241, 0.3);
        border-radius: 12px;
        overflow: hidden;
        z-index: 1000;
        opacity: 0;
        visibility: hidden;
        transform: translateY(-10px);
        transition: all 0.3s ease;
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
    }

    .custom-select-option {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 8px 16px;
        min-height: 44px;
        color: #cbd5e1;
        font-size: 14px;
        line-height: 16px;
        cursor: pointer;
        transition: all 0.2s ease;
        width: 95%;
        margin: 10px auto;
        border-radius: 12px;

        &:hover {
            background: rgba(99, 102, 241, 0.15);
            color: #f1f5f9;
        }

        &.active {
            background: linear-gradient(135deg, #6366f1, #a855f7);
            color: white;

            i {
                color: white;
                font-size: 12px;
            }
        }

        i {
            color: #818cf8;
            font-size: 12px;
        }

        span {
            font-size: 10px;
            opacity: 0.8;
        }
    }
}
</style>